export default class Piece {
  constructor(player, iconUrl) {
    this.player = player;
    this.style = this.player===1? { backgroundImage: "url('" + iconUrl + "')" }:{  backgroundSize: "50%", top:"-25px", backgroundImage: "url('" + iconUrl + "')" };
    this.src = iconUrl;
  }

  getPlayer() {
    return this.player
  }
}